import { memo } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/icons/icon-24-images-large.tsx
/**
* icon.24.images.large
*
* Keywords: photo, image, picture, gallery, square-frame, mountain-landscape, sun, photography
*
* ![](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDI0IDI0Ij48cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9IiMwMDAiIHJ4PSI0Ii8+PHBhdGggZmlsbD0iI2ZmZiIgZD0iTTE4LjIwNCA4LjAxQTIgMiAwIDAgMSAyMCAxMHY4bC0uMDEuMjA0YTIgMiAwIDAgMS0xLjc4NiAxLjc4NUwxOCAyMGgtOGEyIDIgMCAwIDEtMS45OS0xLjc5Nkw4IDE4di04YTIgMiAwIDAgMSAyLTJoOHpNMTAgOWExIDEgMCAwIDAtMSAxdjhhMSAxIDAgMCAwIDEgMWg4YTEgMSAwIDAgMCAxLTF2LThhMSAxIDAgMCAwLTEtMXptMS43MjUgNC41ODJhLjUuNSAwIDAgMSAuNjI5LjA2NGwzLjUgMy41YS41LjUgMCAxIDEtLjcwNy43MDdMMTIgMTQuNzA4bC0xLjE0NiAxLjE0NmEuNS41IDAgMSAxLS43MDctLjcwN2wxLjUtMS41em0yLjQ4LTkuNTcxQTIgMiAwIDAgMSAxNiA2di41YS41LjUgMCAwIDEtMSAwVjZhMSAxIDAgMCAwLTEtMUg2YTEgMSAwIDAgMC0xIDF2OGExIDEgMCAwIDAgMSAxaC41YS41LjUgMCAwIDEgMCAxSDZhMiAyIDAgMCAxLTEuOTktMS43OTZMNCAxNFY2YTIgMiAwIDAgMSAyLTJoOHpNMTYgMTBhMiAyIDAgMSAxIDAgNCAyIDIgMCAwIDEgMC00bTAgMWExIDEgMCAxIDAgMCAyIDEgMSAwIDAgMCAwLTIiLz48L3N2Zz4=)
*
* https://staging.figma.com/file/ycDPAaAih2bZY5LgXehVai/?node-id=21992-8490
*/
const Icon24ImagesLarge = memo(function Icon24ImagesLarge(props) {
	return /* @__PURE__ */ jsx("svg", {
		width: "24",
		height: "24",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		"data-fpl-icon-size": "24L",
		children: /* @__PURE__ */ jsx("path", {
			fill: "var(--fpl-icon-color, var(--color-icon))",
			d: "M18.204 8.01A2 2 0 0 1 20 10v8l-.01.204a2 2 0 0 1-1.786 1.785L18 20h-8a2 2 0 0 1-1.99-1.796L8 18v-8a2 2 0 0 1 2-2h8zM10 9a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-8a1 1 0 0 0-1-1zm1.725 4.582a.5.5 0 0 1 .629.064l3.5 3.5a.5.5 0 1 1-.707.707L12 14.708l-1.146 1.146a.5.5 0 1 1-.707-.707l1.5-1.5zm2.48-9.571A2 2 0 0 1 16 6v.5a.5.5 0 0 1-1 0V6a1 1 0 0 0-1-1H6a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h.5a.5.5 0 0 1 0 1H6a2 2 0 0 1-1.99-1.796L4 14V6a2 2 0 0 1 2-2h8zM16 10a2 2 0 1 1 0 4 2 2 0 0 1 0-4m0 1a1 1 0 1 0 0 2 1 1 0 0 0 0-2"
		})
	});
});
//#endregion
export { Icon24ImagesLarge };

//# sourceMappingURL=icon-24-images-large.js.map